import { api, CommonHeaderProperties } from "../Configurations/axios";

const GetPercentageValidatedFeaturesTechnologies = async (registerId: string, access_token: string) => {
    try {
        api.defaults.headers = {
            Authorization: `Bearer ${access_token}`,
        } as CommonHeaderProperties;

        var result = await api.post(`/PercetangeValidationFinep/GetPercentageValidatedFeaturesTechnologies`, { registerId: registerId });
        return result.data;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetPercentageValidatedPersonaPJPF = async (registerId: string, access_token: string) => {
    try {
        api.defaults.headers = {
            Authorization: `Bearer ${access_token}`,
        } as CommonHeaderProperties;

        var result = await api.post(`/PercetangeValidationFinep/GetPercentageValidatedPersonaPJPF`, { registerId: registerId });
        return result.data;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetPercentageValidatedRegistrationDocuments = async (registerId: string, access_token: string) => {
    try {
        api.defaults.headers = {
            Authorization: `Bearer ${access_token}`,
        } as CommonHeaderProperties;

        var result = await api.post(`/PercetangeValidationFinep/GetPercentageValidatedRegistrationDocuments`, { registerId: registerId });
        return result.data;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetPercentageValidatedFeaturesTechnologies,
    GetPercentageValidatedPersonaPJPF,
    GetPercentageValidatedRegistrationDocuments,
}